import { compose } from 'ramda';
import { connect } from 'react-redux';

import queryDuck from '@/features/anonymousPurchasesStatisticsPage/ducks/query';
import {
  getError,
  getItemsIds,
  getItemsTotalCount,
  isLoadingItems,
} from '@/features/anonymousPurchasesStatisticsPage/selectors';
import { getStatsIds } from '@/features/statisticsPage/selectors';
import withQuerySync from '@/hocs/withQuerySync';

import AnonymousPurchasesStatistics from './component';

const mapStateToProps = state => ({
  error: getError(state),
  itemsIds: getItemsIds(state),
  isLoading: isLoadingItems(state),
  totalCount: getItemsTotalCount(state),
  statsIds: getStatsIds(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
)(AnonymousPurchasesStatistics);
